<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 108.25 116.69" xml:space="preserve">
    <g>
        <polygon [style.fill]="fill" points="17.4,2.43 2.24,26.79 25.75,26.79" />
        <polygon [style.fill]="fill" points="102.74,115.03 60.25,92.72 17.75,115.19 17.75,2.43 102.74,2.43" />
    </g>
    <text transform="matrix(0.9877 0 0 1 43.7073 71.4295)">R</text>
</svg>